import Immutable from 'immutable';

import { UPDATE_PROGRESS } from '../actions/progressbar';
import {
    SHARED_COUNT_FETCH_ERROR,
    SHARED_COUNT_UPDATE,
    SHARED_COUNT_UNREGISTER,
} from '../actions/sharedCount';

const UTILS = 'utils';
const SHARED_COUNT = 'sharedCount';
const PROGRESSBAR = 'progressbar';
const PERSISTENT_STATE = 'persistentState';

const initialState = Immutable.fromJS({
    sharedCount: {},
    progressbar: {},
});

export default function utils(state = initialState, action) {
    switch (action.type) {
        case SHARED_COUNT_UPDATE:
            return state.setIn([SHARED_COUNT], Immutable.fromJS(action.payload.data));
        case SHARED_COUNT_FETCH_ERROR:
            return state.setIn([SHARED_COUNT], Immutable.Map());
        case SHARED_COUNT_UNREGISTER:
            return state.deleteIn([SHARED_COUNT]);
        case UPDATE_PROGRESS:
            return state.setIn([PROGRESSBAR], Immutable.fromJS(action.payload));
        case 'PERSISTENT_STATE_LOADED':
            return state.setIn([PERSISTENT_STATE], action.payload);
        default:
            return state;
    }
}

export const sharedCountSelector = (state) => {
    return state.getIn([UTILS, SHARED_COUNT], Immutable.Map());
};
export const progressbarSelector = (state) => {
    return state.getIn([UTILS, PROGRESSBAR]);
};

export const persistentStateLoadedSelector = (state) => {
    return state.getIn([UTILS, PERSISTENT_STATE], false);
};
